import ServiceApi from "../services/service.api";
const baseServiceUrl = `/api/v1/filesservicecontroler`;



const env = process.env;

const ApiFilesService = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getFileType: () => {
    const url = `${baseServiceUrl}/GetFileType`;
    return ServiceApi.get(url);
  },
  saveFileInfo: (params) => {
    const url = `${baseServiceUrl}/saveFileInfo`;
    return ServiceApi.post(url, params);
  },
  uploadFiles: (params) => {
    const url = `${baseServiceUrl}/uploadFiles`;
    return ServiceApi.post(url, params, { baseURL: env.REACT_APP_PHOTOPATH_WEB });
  },
  getBasketItemFile: (params) => {
    const url = `${baseServiceUrl}/getItemFilesByDifferentId`;
    return ServiceApi.get(url, { params });
  },
  getFile: (params) => {
    const url = `${baseServiceUrl}/getFile`;
    return ServiceApi.get(url, { params: params, baseURL: env.REACT_APP_PHOTOPATH_WEB, responseType: 'blob' });

  },
  changeActived: (params) => {
    const url = `${baseServiceUrl}/changeActived`;
    return ServiceApi.put(url, params);
  },
  changeVoucherFileStatus: (params) => {
    const url = `${baseServiceUrl}/changeVoucherFileStatus`;
    return ServiceApi.put(url, params);
  },
  createTicketCode: (params) => {
    const url = `${baseServiceUrl}/createFileForTicketCode`;
    return ServiceApi.post(url, params);
  },
};

export default ApiFilesService;


